import styled from 'styled-components';
import {
  Space,
  InputWithAction,
  Button,
  InputField,
  Checkbox,
} from '@cashfree-intl/coherent';
import { Image } from 'components/Image';

export const StyledPaytmCard = styled.div`
  .payment-mode {
    grid-template-columns: 1.5fr 3fr 1.5fr !important;
    border-bottom: 0 !important;
    padding-bottom: 0 !important;
    .display-text-section {
      div:last-child {
        margin-left: 0.5rem;
      }
    }
    & > div:last-child {
      justify-self: end;
    }
  }
`;

export const StyledDivider = styled.div`
  height: 1px;
  background: var(--SECONDARY_LIGHTER);
  margin: 1.25rem 2rem 1.25rem 0.875rem;
`;

export const ForexMarkupDescription = styled.div`
  margin-bottom: 0.75rem;
  color: var(--SECONDARY_LIGHT);
  a {
    text-decoration: none;
  }
`;

export const StyledToggleWrapper = styled.div`
  margin-right: 79px;
`;

export const StyledPaypalTransactionCharges = styled(Space)`
  margin-bottom: 0.875rem;
`;

export const StyledInputWithAction = styled(InputWithAction)`
  .ui.label.label {
    max-width: 2.5rem;
  }
  input {
    max-width: 111px !important;
  }
`;

export const StyledInputWrapper = styled(Space)`
  & > div {
    min-width: fit-content;
  }
`;

export const StyledLinkButton = styled(Button)`
  min-width: unset;
`;

export const StyledRow = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  border-radius: 0.625rem;
  border: 1px solid #e6e5e8;
  padding: 1rem;
  grid-gap: 1rem;
`;

export const StyledColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.3fr 0.875rem;
  grid-gap: 1.5rem;
`;

export const StyledSavings = styled.div`
  padding: 1rem 1.5rem;
  border-radius: 0.625rem;
  border: 1px solid #e6e5e8;
  & > div:last-child {
    margin-top: 0.75rem;
  }
  & > div:nth-child(2) {
    font-weight: 700;
  }
`;

export const StyledForexCalculator = styled(Space)``;

export const TableWrapper = styled.div`
  border-radius: 10px;
  border: 1px solid #e6e5e8;
  width: 100%;
`;

export const MarkupTable = styled.table`
  width: 100%;
  thead {
    th {
      background: #f7f7f8;
      padding: 14px 36px;
      & > div {
        text-align: justify;
      }
      &:first-child {
        border-top-left-radius: 9px;
      }
      &:last-child {
        border-top-right-radius: 9px;
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #e6e5e8;
      td {
        padding: 16px 36px;
        color: var(--SECONDARY_LIGHT);
        &: first-child {
          padding-left: 24px;
        }
      }
      &: last-child {
        padding: 1.5rem;
        border-bottom: none;
        td {
          background: #d9e7f2;
          color: var(--SECONDARY_DARK);
          &:first-child {
            font-weight: 700;
            border-bottom-left-radius: 9px;
            font-family: 'proxima-nova-bold';
          }
          font-family: 'proxima-nova-medium';
          &:last-child {
            border-bottom-right-radius: 9px;
          }
        }
      }
    }
  }
`;

export const StyledInputField = styled(InputField)`
  label {
    display: none;
  }
  .ui.input {
    margin-bottom: 0 !important;
    input {
      max-width: 3.625rem;
    }
  }
  .mt-1 {
    position: absolute;
  }
`;

export const StyledUploadSpace = styled(Space)`
  & div:first-child {
    flex-grow: 1;
  }
`;

export const StyledMarkupInputWrapper = styled(Space)`
  max-width: 42.5rem;
`;

export const MarkupBanner = styled(Space)`
  background: linear-gradient(to right, #0f0c29 0%, #302b63 53%, #162e70 100%);
  border-radius: 0.75rem;
  button {
    background: #20ffbc;
  }
`;

export const StyledForexMarkupStatus = styled(Space)`
  & > div:first-child {
    min-width: fit-content;
  }
  & > div:last-child {
    min-width: 2rem;
  }
`;

export const StyledPaymentMethodIcon = styled(Image)`
  height: 1.5rem;
  &.paytm {
    height: 2.25rem;
  }
  &.credpay,
  &.visa,
  &.rupay,
  &.maestro,
  &.mastercard {
    height: 2rem;
  }
`;

export const StyledConnectPaypalRadioButton = styled.div`
  .inline.fields .field label {
    color: ${props => props.theme.COLORS.body};
  }
`;

export const StyledConnectPaypalCheckbox = styled(Checkbox)`
  min-height: unset !important;
  label {
    color: ${props => props.theme.COLORS.body} !important;
  }
`;
